import { DashboardSettingsService } from '@api'

export const setCountdownAudioFile = async ({
  creatorId,
  sound,
}: {
  creatorId: number
  sound: string
}) => {
  return DashboardSettingsService.updateCountdownAudioSound({
    creatorId,
    sound,
  })
}

export const setCountdownAudioVolume = async ({
  creatorId,
  volume,
}: {
  creatorId: number
  volume: number
}) => {
  return DashboardSettingsService.updateCountdownAudioVolume({
    creatorId,
    volume,
  })
}

export const toggleEmojiTaskbar = async ({
  creatorId,
  toggleState,
}: {
  creatorId: number
  toggleState: boolean
}) => {
  return DashboardSettingsService.toggleEmojiTaskbarState({
    creatorId,
    state: toggleState,
  })
}

export const setEmojiTaskbar = async ({
  creatorId,
  emojis,
}: {
  creatorId: number
  emojis: string
}) => {
  return DashboardSettingsService.updateEmojiTaskbar({
    creatorId,
    requestBody: {
      taskbar: emojis,
    },
  })
}

export const enableCustomNotePreset = async ({
  creatorId,
  enabled,
}: {
  creatorId: number
  enabled: boolean
}) => {
  return DashboardSettingsService.toggleCustomNotePreset({
    creatorId,
    state: enabled,
  })
}

export const setCustomNodePreset = async ({
  creatorId,
  note,
}: {
  creatorId: number
  note: string
}) => {
  return DashboardSettingsService.updateCustomNotePreset({
    creatorId,
    requestBody: {
      note,
    },
  })
}

export const displaySettingsService = {
  setCountdownAudioVolume,
  setCountdownAudioFile,
  toggleEmojiTaskbar,
  setEmojiTaskbar,
  enableCustomNotePreset,
  setCustomNodePreset,
}
